import {
  StyledContainer,
  StyledTitle,
  StyledDescription,
  StyledBenefitContainer,
  StyledBenefitItem,
  StyledButton,
  StyledMain,
  StyledIcon,
  StyledCloseButton,
  StyledCloseIcon,
} from './styles/PreSignupContent.style'

interface PreSignupContentProps {
  onPrimaryClick: () => void
  primaryLabel?: string
  className?: string
  isModalOpen?: boolean
  hide?: () => void
}

export const PreSignupContent = ({
  onPrimaryClick,
  primaryLabel = 'Fazer pré-cadastro',
  className,
  isModalOpen = false,
  hide,
}: PreSignupContentProps) => {
  return (
    <StyledMain isModalOpen={isModalOpen}>
      {isModalOpen && (
        <StyledCloseButton onClick={hide}>
          <StyledCloseIcon />
        </StyledCloseButton>
      )}
      <StyledContainer className={className} data-cy="pre-signup-content" isModalOpen={isModalOpen}>
        <StyledTitle>Quer ofertas exclusivas todo dia?</StyledTitle>

        <StyledDescription>
          Faça seu pré-cadastro e um dos nossos representantes entrará em contato
        </StyledDescription>

        <StyledBenefitContainer>
          <StyledBenefitItem>
            <StyledIcon src="/img/packageIcon.png" alt="" />
            Mais de 2000 produtos
          </StyledBenefitItem>
          <StyledBenefitItem>
            <StyledIcon src="/img/attach_money.png" alt="" />
            Sem pedido mínimo
          </StyledBenefitItem>
        </StyledBenefitContainer>

        <StyledButton type="button" onClick={onPrimaryClick} data-cy="pre-signup-cta">
          {primaryLabel}
        </StyledButton>
      </StyledContainer>
    </StyledMain>
  )
}

export default PreSignupContent
